import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import { ClientSentryIgnoreRule } from '@/shared/utils/sentry/clientIgnoreRules/types';

const UNEXPECTED_END_OF_SCRIPT_MESSAGE = 'unexpected end of script';
const INJECTED_INIT_SCRIPT_PATH_PATTERN =
  /^app:\/\/\/[A-Za-z0-9_-]+\/init\.js$/;
const SELLER_UI_APP_FRAME_MARKERS = [
  'webpack://_n_e/./src/',
  'webpack://_n_e/src/',
  'webpack://_n_e/./pages/',
  'webpack://_n_e/pages/',
  '/_next/static/chunks/',
] as const;

const isUnexpectedEndOfScript = (message: unknown): boolean =>
  toNormalizedMessage(message) === UNEXPECTED_END_OF_SCRIPT_MESSAGE;

const hasInjectedInitScriptFrame = (
  stackFrameFilenames: readonly string[]
): boolean =>
  stackFrameFilenames.some((frameFilename) =>
    INJECTED_INIT_SCRIPT_PATH_PATTERN.test(frameFilename)
  );

const hasSellerUiAppStackFrame = (
  stackFrameFilenames: readonly string[]
): boolean =>
  stackFrameFilenames.some((filename) => {
    const normalizedFilename = toNormalizedMessage(filename);

    return Boolean(
      normalizedFilename &&
      SELLER_UI_APP_FRAME_MARKERS.some((marker) =>
        normalizedFilename.includes(marker)
      )
    );
  });

export const syntaxErrorUnexpectedEndOfInjectedInitScriptRule: ClientSentryIgnoreRule =
  {
    id: 'syntax-error-unexpected-end-of-injected-init-script',
    references: ['FTR-2740'],
    reason:
      'Known third-party/injected init script parse noise with no actionable seller-ui source context',
    matches: ({
      firstExceptionType,
      serializedMessage,
      stackFrameFilenames,
    }) => {
      if (firstExceptionType !== 'SyntaxError') {
        return false;
      }

      if (hasSellerUiAppStackFrame(stackFrameFilenames)) {
        return false;
      }

      return (
        isUnexpectedEndOfScript(serializedMessage) &&
        hasInjectedInitScriptFrame(stackFrameFilenames)
      );
    },
  };
